/*
 * @Description: 
 * @Author: Hehuiling
 * @version: 
 * @Date: 2024-03-04 12:16:02
 * @LastEditors: Hehuiling
 * @LastEditTime: 2024-03-07 15:58:24
 */
export const payWayObj = {
    1: '营业厅现金',2: '扫码支付',3: '对公转账','wechat_pay': '微信支付',
}
export const payTypeObj = {
    1:'充值',2:'退费',3:'补水',4:'撤销充值',5:'撤销退费',6:'撤销补水'
}
export const meterTypeObj = {
    "80": "WN100","18":"MN100","12":"MN100","20":"超声波水表","40": "暖通阀","20-2":"超声波水表","MN100-2D": "MN100-2D","15": "W12-N","Y14-4G":"Y14-4G","Y10-QN":"Y10-QN","Y17-N":"Y17-N","Y18-N":"Y18-N"
}
export const messageFrequencyObj ={
    1: '一天一次',2: '一周一次',3: '一月一次'
}
export const messageTypeObj ={
    1: '短信模板',2: '微信模板'
}
export const messageSendWayObj ={
    1: '短信',2: '微信消息'
}
export const messageSendFlagObj ={
    1: '剩余金额告警',
    2: '余额不足告警'
}
export const messageSuccFlagObj ={
    1: '成功',0: '失败','-1': '未绑定'
}
export const deviceTypeObj ={
    0: '微信公众号',1: '充值机',2: '支付宝',3: '银行app'
}

export const accountChangeObj ={
    1: '激活计费',2: '充值',3: '补水',4: '撤销充值',5: '退费',6: '换表',
    7: '撤销补水',8: '上报计费',9: '退费撤销',14: '恢复撤销充值',17: '恢复撤销补水',19: '恢复撤销退费',88: '刷卡计费'
}
export const meterWarnTypeObj = {
    1: '电池欠压',
    2: '磁干扰',
    3: '存储器故障',
    4: '逆流故障',
    5: '阀门故障'
}